import { Pipe, PipeTransform } from '@angular/core';
import { Level } from '@core/models/common.model';
import { Rate, getRatePrice } from '@core/models/edition.model';

@Pipe({
  name: 'ratePrice',
})
export class RatePricePipe implements PipeTransform {
  transform(rate: Rate, level?: Level, levelPricesEnabled?: boolean): number {
    return getRatePrice(rate, level, levelPricesEnabled);
  }
}
